import React from "react";
import Footer from "../components/Footer/index";
import { TinkerpreneurSubmissionForm } from "../components/TinkerpreneurSubmission";

const ATLTinkerpreneurSubmission2026 = () => {
  return (
    <>
      <TinkerpreneurSubmissionForm
        year={2026}
        faqUrl="/assets/pdf/tinkerpreneur-2026-faq.pdf"
        evaluationParamsUrl="/assets/pdf/tinkerpreneur-2026-evaluation-parameters.pdf"
      />
      <Footer />
    </>
  );
};

export default ATLTinkerpreneurSubmission2026;
